/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateV2GetParamsResponse {
    getFixupPrototypeFunction() { return TemplateV2GetParamsResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateV2GetParamsResponse>): TemplateV2GetParamsResponse {
        let obj = Object.assign(new TemplateV2GetParamsResponse(), model);
        TemplateV2GetParamsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateV2GetParamsResponse>): TemplateV2GetParamsResponse {
        if (!model) return null;
        return TemplateV2GetParamsResponse.newInstance(<TemplateV2GetParamsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateV2GetParamsResponse) {
        if (!obj) return;

        models.TemplateV2GetParamsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateV2GetParamsResponse): boolean {
        Object.setPrototypeOf(obj, TemplateV2GetParamsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.params) {
            for (let val of this.params) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
        if (this.parameter_groups) {
            for (let val of this.parameter_groups) {
                models.TemplateParameterGroup.fixupPrototype(val);
            }
        }
        if (this.service_accounts) {
            for (let val of this.service_accounts) {
                models.TemplateServiceAccount.fixupPrototype(val);
            }
        }
    }

    /**
     * Parameters required to execute this template - name, type, whether required, and default value, if any
     */
    params: Array<models.NamedParameter>;

    /**
     * Groups used to organize parameters into UI form sections, each listing its own parameter names. Empty if this template doesn't declare groups
     */
    parameter_groups: Array<models.TemplateParameterGroup>;

    /**
     * Echoed back exactly as submitted in the request
     */
    service_accounts: Array<models.TemplateServiceAccount>;

}
